<template>
  <div v-loading="loading" element-loading-text="加载中">
    <el-row>
      <el-col :span="24">
        <div class="element-select">
          <el-select v-model="value" @change="adminModulePointPieCopy" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div  id="charts-box-copy-lpie"></div>
        <!-- <div v-else class="empty">暂无数据</div> -->
      </el-col>
    </el-row>
  </div>
</template>

<script>
import echarts from "echarts";
import { API__code, API_Admin } from "../../../api/index.js";
export default {
  props:['userid'],
  data() {
    return {
      chartsXAxis: [],
      //折线图数据
      chartsData: [],
      value: "1",
      loading:false,
      options: [
        {
          value: "1",
          label: "最近一个月",
        },
        {
          value: "3",
          label: "最近三个月",
        },
        {
          value: "6",
          label: "最近半年",
        },
        {
          value: "12",
          label: "最近一年",
        },
      ],
      chartPie:[],
      legend:[],
      checkCode:'',
      token:''
    };
  },
  created() {
    this.getCookie();
  },
  mounted() {
    this.getData();
  },
  methods: {
    //读取cookie
    getCookie: function() {
        if (document.cookie.length > 0) {
            var arr = document.cookie.split('; ');
            for (var i = 0; i < arr.length; i++) {
                var arr2 = arr[i].split('=');
                if (arr2[0] == 'dnnyptadmin_token') {
                    this.token = arr2[1];
                } else if (arr2[0] == 'dnnyptadmin_checkCode') {
                    this.checkCode = arr2[1];
                } 
            }
        }
    },
    getData() {
      this.adminModulePointPieCopy();
    },
    adminModulePointPieCopy(val) {
      var param = {
        count: this.value,
        userid:this.userid,
        token:this.token,
        checkCode:this.checkCode,
      };
      this.loading = true
      API_Admin.getUserModulePointPie(param).then((res) => {
        if(res.data.code == 200){
        var list = [];
        var data = res.data.data;
        var legend = [];
        for(var p in data){
          list.push({ name: data[p].modulename, value: data[p].sumpoint });
          legend.push(data[p].modulename)
        }
        this.chartPie = list;
        this.legend = legend;
        this.initCharts();
        this.loading = false;
        }
      });
    },
    initCharts() {
      var charts = null;
      charts = echarts.init(document.getElementById("charts-box-copy-lpie"));
      charts.showLoading(); //显示等待框
      charts.setOption({
        title: {
          text: "模块使用情况分析",
          top: "top",
          left: "left",
          textStyle: {
            color: "#596471",
            fontSize: 18,
            fontWeight: 400,
            fontFamily: 'SourceHanSansCN'
          },
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        legend: {
          orient: "horizontal",
          left: 10,
          data: this.legend,
          bottom: 0,
        },
        series: [
          {
            name: "模块使用情况分析",
            type: "pie",
            radius: "55%",
            center: ["50%", "45%"],
            data: this.chartPie,
            emphasis: {
              
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            label: {
                show: true,
                color:'black',
                formatter: function (params) {
                        return params.value;
                },
            }
          },
        ],
        color:['#FF6383','#FF9F40','#FFCB48','#5C89FF','#7C6AF2','#C95FF2']
      });
      charts.hideLoading(); //隐藏等待框
      //this.loading = false;
    },
  },
};
</script>

<style scoped lang="scss">
#charts-box-copy-lpie {
  width: 100%;
  height: 336px;
  background-color: white;
  border-radius: 2px;
}

.element-select {
  float: right;
  position: relative;
  z-index: 888;
}

.empty{
  height: 300px;
  width: 100%;
  text-align: center;
  line-height: 300px;
  color: #596471;
}
</style>



// WEBPACK FOOTER //
// rightCharts.vue?46770014